import { useMemo, useState } from "react";
import { BlobProvider } from "@react-pdf/renderer";
import Preview from "./Preview";
import { useResumeData } from "../hooks/useResumeData";
import { Viewer, Worker } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useSelector } from "react-redux";
import { State } from "../props/State.props";
import { AiOutlineClose } from "react-icons/ai";

const PreviewResume = ({ theme = "light" }: { theme: string }) => {
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [resumeData] = useResumeData();
  const getFontFamily = useSelector((state: State) => state.getFontFamily);

  const getTheme: { [key: string]: { [key: string]: string | undefined } } = {
    dark: {
      bg: "#191D20",
      fg: "#E3E3E3",
    },
    light: {
      bg: "#E3E3E3",
      fg: "#191D20",
    },
  };

  const [showPreview, setShowPreview] = useState(false);

  const renderPreview = useMemo(() => {
    return (
      <div className="w-full h-full fixed z-[9999] top-0 left-0 flex justify-center items-center">
        <div className="w-full h-full fixed z-[9999]">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js">
            <BlobProvider
              document={
                <Preview
                  resumeData={resumeData}
                  date={new Date()}
                  theme={getTheme[theme]}
                  font={getFontFamily}
                />
              }
            >
              {({ blob }) => {
                if (blob) {
                  const url = URL.createObjectURL(blob);
                  return (
                    <Viewer
                      fileUrl={url}
                      // plugins={[defaultLayoutPluginInstance]}
                      theme="dark"
                      defaultScale={1.5}
                    />
                  );
                }
              }}
            </BlobProvider>
          </Worker>
        </div>
        <div
          className="fixed flex justify-center items-center z-[9999] top-5 right-5 w-10 h-10 bg-light-bg text-light-fg rounded-full text-sm font-bold cursor-pointer border border-dark-bg"
          onClick={() => {
            setShowPreview(!showPreview);
          }}
          title="Close Preview"
        >
          <AiOutlineClose />
        </div>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPreview]);

  return (
    <>
      <div
        className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
        onClick={() => setShowPreview(!showPreview)}
      >
        <i className="fa fa-file-pdf" />
        <div className="text-left">Preview Resume</div>
      </div>
      {showPreview && renderPreview}
    </>
  );
};

export default PreviewResume;
